/*!
 * Sales Pop — Shopify social proof widget (no monthly fee alternative to Qikify Sales Pop).
 * Single-file IIFE. Reads window.SalesPopConfig. Injects its own <style>.
 */
(function () {
  'use strict';

  if (window.__salesPopLoaded) return;
  window.__salesPopLoaded = true;

  var DEFAULTS = {
    collectionHandle: 'frontpage',
    names: [],
    cities: [],
    position: {
      placement: 'bottom-left', // bottom-left | bottom-right | top-left | top-right
      offsetBottom: 100,
      offsetLeft: 40,
      offsetTop: 20,
      offsetRight: 20
    },
    timing: {
      initialDelay: 5000,
      displayDuration: 6000,
      intervalBetween: 10000,
      randomness: 0
    },
    behavior: {
      showOnMobile: false, // Qikify "Hide on Mobile" = checked
      maxPerSession: 7,
      pauseOnClose: true,
      showCloseButton: false,
      showMeta: true,        // įjungta „prieš X min" eilutė
      showVerified: false,   // be „Patvirtintas pirkimas ✓"
      minMinutesAgo: 1,
      maxMinutesAgo: 15,
      productTitleMaxChars: 40,
      // Puslapiai, kuriuose pranešimai NEBUS rodomi.
      // Jei pavyzdys baigiasi „/", tai prefix match (pvz. /blogs/ → visi tinklaraščio puslapiai).
      // Be „/" pabaigoje — tikslus atitikimas (pvz. /cart → tik krepšelis).
      excludePages: ['/cart', '/blogs/']
    },
    text: {
      template: '{CUSTOMER}, {LOCATION}, LT',
      productTemplate: 'Užsisakė: {PRODUCT}',
      timeAgoTemplate: 'prieš {minutes} min',
      verifiedText: 'Patvirtintas pirkimas',
      closeLabel: 'Uždaryti'
    },
    // Firebase Firestore analytics. If projectId + apiKey are set, widget posts
    // an "impression" event when a popup is shown and a "click" event when it
    // is clicked. Read by dashboard.html.
    analytics: {
      projectId: null,
      apiKey: null
    }
  };

  function deepMerge(target, src) {
    if (!src || typeof src !== 'object') return target;
    var out = {};
    Object.keys(target).forEach(function (k) { out[k] = target[k]; });
    Object.keys(src).forEach(function (k) {
      if (src[k] && typeof src[k] === 'object' && !Array.isArray(src[k])) {
        out[k] = deepMerge(target[k] || {}, src[k]);
      } else if (src[k] !== undefined) {
        out[k] = src[k];
      }
    });
    return out;
  }

  var config = deepMerge(DEFAULTS, window.SalesPopConfig || {});

  var DEBUG =
    document.body && document.body.getAttribute('data-sales-pop-debug') === 'true';
  function log() {
    if (!DEBUG) return;
    var args = ['[SalesPop]'].concat(Array.prototype.slice.call(arguments));
    console.log.apply(console, args);
  }

  if (DEBUG) {
    config.timing.initialDelay = Math.round(config.timing.initialDelay / 10);
    config.timing.displayDuration = Math.round(config.timing.displayDuration / 10);
    config.timing.intervalBetween = Math.round(config.timing.intervalBetween / 10);
    config.timing.randomness = Math.round(config.timing.randomness / 10);
    log('Debug mode on — timings scaled to 1/10', config.timing);
  }

  var SESSION_COUNT_KEY = 'sp_shown_count';
  var SESSION_DISMISSED_KEY = 'sp_dismissed';
  var SESSION_ID_KEY = 'sp_session_id';
  var SESSION_EXPIRY_KEY = 'sp_session_expiry';
  var ENGAGED_KEY = 'sp_engaged';
  var LAST_PAGEVIEW_KEY = 'sp_last_pv';
  var SESSION_TTL_MS = 30 * 60 * 1000;

  function sessionGet(k) {
    try { return window.sessionStorage && sessionStorage.getItem(k); } catch (e) { return null; }
  }
  function sessionSet(k, v) {
    try { window.sessionStorage && sessionStorage.setItem(k, v); } catch (e) {}
  }
  function localGet(k) {
    try { return window.localStorage && localStorage.getItem(k); } catch (e) { return null; }
  }
  function localSet(k, v) {
    try { window.localStorage && localStorage.setItem(k, v); } catch (e) {}
  }
  function localRemove(k) {
    try { window.localStorage && localStorage.removeItem(k); } catch (e) {}
  }

  // Persistent session across tabs / page loads with 30-min sliding expiry.
  function getSessionId() {
    var now = Date.now();
    var id = localGet(SESSION_ID_KEY);
    var expiry = parseInt(localGet(SESSION_EXPIRY_KEY) || '0', 10);
    if (!id || !expiry || now > expiry) {
      id = 'sess_' + now.toString(36) + '_' + Math.random().toString(36).slice(2, 10);
      localSet(SESSION_ID_KEY, id);
      localRemove(ENGAGED_KEY);
      localRemove(LAST_PAGEVIEW_KEY);
    }
    localSet(SESSION_EXPIRY_KEY, String(now + SESSION_TTL_MS));
    try {
      document.cookie = 'sp_session_id=' + encodeURIComponent(id) +
        '; path=/; max-age=' + Math.floor(SESSION_TTL_MS / 1000) + '; SameSite=Lax';
    } catch (e) {}
    return id;
  }
  function markEngaged() { localSet(ENGAGED_KEY, '1'); }
  function isEngaged() { return localGet(ENGAGED_KEY) === '1'; }

  function firestoreValue(v) {
    if (typeof v === 'number' && isFinite(v) && Math.floor(v) === v) {
      return { integerValue: String(v) };
    }
    return { stringValue: String(v == null ? '' : v) };
  }

  function trackEvent(type, extra) {
    var a = config.analytics || {};
    if (!a.projectId || !a.apiKey) return;
    try {
      var fields = {
        type: firestoreValue(type),
        sessionId: firestoreValue(getSessionId()),
        url: firestoreValue(String(window.location.href).slice(0, 500)),
        timestamp: firestoreValue(Math.floor(Date.now() / 1000))
      };
      if (extra && typeof extra === 'object') {
        if (extra.productId != null) fields.productId = firestoreValue(String(extra.productId));
        if (extra.productTitle) fields.productTitle = firestoreValue(String(extra.productTitle));
        if (extra.productHandle) fields.productHandle = firestoreValue(String(extra.productHandle));
        if (extra.path) fields.path = firestoreValue(String(extra.path));
        if (extra.referrer) fields.referrer = firestoreValue(String(extra.referrer).slice(0, 500));
      }
      var body = JSON.stringify({ fields: fields });
      var url = 'https://firestore.googleapis.com/v1/projects/' +
        encodeURIComponent(a.projectId) +
        '/databases/(default)/documents/events?key=' +
        encodeURIComponent(a.apiKey);

      if (type === 'click' && navigator.sendBeacon) {
        var blob = new Blob([body], { type: 'application/json' });
        if (navigator.sendBeacon(url, blob)) return;
      }
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: body,
        keepalive: true
      }).catch(function () {});
    } catch (e) {
      log('trackEvent error', e);
    }
  }

  // Fire a pageview on every page load if the user has previously clicked a
  // popup within this session. De-duplicates within a 2-second window so that
  // reloads / quick navigations don't double-count.
  (function firePageviewIfEngaged() {
    getSessionId();
    if (!isEngaged()) return;
    var now = Date.now();
    var last = parseInt(localGet(LAST_PAGEVIEW_KEY) || '0', 10);
    if (last && (now - last) < 2000) return;
    localSet(LAST_PAGEVIEW_KEY, String(now));

    var path = window.location.pathname;
    var extra = { path: path, referrer: document.referrer || '' };
    var pm = path.match(/^\/products\/([^\/\?]+)/);
    if (pm) extra.productHandle = pm[1];
    trackEvent('pageview', extra);
  })();

  if (config.behavior.pauseOnClose && sessionGet(SESSION_DISMISSED_KEY) === '1') {
    log('User dismissed earlier this session — not showing');
    return;
  }

  if (!config.behavior.showOnMobile && window.innerWidth < 768) {
    log('Mobile viewport and showOnMobile=false — skipping');
    return;
  }

  var currentPath = window.location.pathname.replace(/\/+$/, '') || '/';
  var excluded = (config.behavior.excludePages || []).some(function (pattern) {
    if (!pattern) return false;
    if (pattern.slice(-1) === '/') {
      return currentPath.indexOf(pattern) === 0 ||
        currentPath === pattern.slice(0, -1);
    }
    return currentPath === pattern || currentPath.indexOf(pattern + '/') === 0;
  });
  if (excluded) {
    log('Current page excluded:', currentPath);
    return;
  }

  var reducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var CSS =
    '.sp-popup{' +
      'position:fixed;z-index:9999;' +
      'min-width:280px;max-width:calc(100vw - 20px);' +
      'background:#000;color:#fff;' +
      'border-radius:8px;' +
      'box-shadow:0 6px 20px rgba(0,0,0,.25);' +
      'font-family:inherit;' +
      'font-size:14px;line-height:1.35;' +
      'padding:10px 24px 10px 10px;' +
      'opacity:0;' +
      'transition:opacity .3s ease,transform .3s ease,box-shadow .2s ease;' +
      'pointer-events:none;cursor:pointer;' +
    '}' +
    '.sp-popup.sp-pos-bottom-left,.sp-popup.sp-pos-top-left{transform:translateX(-20px);}' +
    '.sp-popup.sp-pos-bottom-right,.sp-popup.sp-pos-top-right{transform:translateX(20px);}' +
    '.sp-popup.sp-show{opacity:1;transform:translateX(0)!important;pointer-events:auto;}' +
    '.sp-popup:hover{box-shadow:0 8px 26px rgba(0,0,0,.35);}' +
    '.sp-popup *{box-sizing:border-box;}' +
    '.sp-row{display:flex;gap:14px;align-items:center;}' +
    '.sp-image{' +
      'flex:0 0 60px;width:60px;height:60px;' +
      'border-radius:4px;' +
      'background:#fff center/contain no-repeat;' +
    '}' +
    '.sp-body{flex:1;min-width:0;padding-right:8px;}' +
    '.sp-headline{' +
      'font-weight:700;color:#fff;font-size:15px;' +
      'white-space:nowrap;overflow:hidden;text-overflow:ellipsis;' +
    '}' +
    '.sp-product{' +
      'color:#fff;font-weight:400;margin-top:2px;' +
      'white-space:nowrap;overflow:hidden;text-overflow:ellipsis;' +
    '}' +
    '.sp-product-name{color:rgb(236,204,189);}' +
    '.sp-meta{' +
      'color:rgba(255,255,255,.65);font-size:12px;margin-top:4px;' +
      'white-space:nowrap;overflow:hidden;text-overflow:ellipsis;' +
    '}' +
    '.sp-check{color:#2ecc71;font-weight:700;margin-left:2px;}' +
    '.sp-close{' +
      'position:absolute;top:8px;right:12px;' +
      'width:20px;height:20px;border:0;background:transparent;' +
      'color:rgba(255,255,255,.6);cursor:pointer;font-size:18px;line-height:20px;' +
      'padding:0;border-radius:50%;font-family:inherit;' +
    '}' +
    '.sp-close:hover{color:#fff;background:rgba(255,255,255,.15);}' +
    '@media (prefers-reduced-motion: reduce){' +
      '.sp-popup{transition:none!important;transform:none!important;}' +
    '}';

  function injectStyles() {
    if (document.querySelector('style[data-sales-pop]')) return;
    var style = document.createElement('style');
    style.setAttribute('data-sales-pop', 'true');
    style.appendChild(document.createTextNode(CSS));
    document.head.appendChild(style);
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function truncate(s, max) {
    s = String(s == null ? '' : s);
    if (s.length <= max) return s;
    return s.slice(0, Math.max(0, max - 1)).replace(/\s+$/, '') + '…';
  }

  function randInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  function pick(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
  }

  function pickDifferent(arr, excludeKey, keyFn) {
    if (arr.length <= 1) return arr[0];
    var chosen;
    var tries = 0;
    do {
      chosen = pick(arr);
      tries++;
    } while (keyFn(chosen) === excludeKey && tries < 10);
    return chosen;
  }

  function render(tpl, vars) {
    return String(tpl).replace(/\{(\w+)\}/g, function (_, k) {
      return vars[k] == null ? '' : vars[k];
    });
  }

  function fetchProducts() {
    if (!config.collectionHandle) {
      console.warn('[SalesPop] Trūksta nustatymo: collectionHandle.');
      return Promise.resolve([]);
    }
    var url = '/collections/' + encodeURIComponent(config.collectionHandle) + '/products.json?limit=50';

    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (data) {
        var raw = (data && data.products) || [];
        var products = raw
          .map(function (p) {
            var img = (p.images && p.images.length) ? p.images[0] : null;
            return {
              id: p.id,
              title: p.title,
              handle: p.handle,
              featuredImage: img ? {
                url: img.src || img,
                altText: img.alt || p.title
              } : null
            };
          })
          .filter(function (p) { return p.title && p.handle && p.featuredImage; });
        log('Loaded products:', products.length);
        return products;
      })
      .catch(function (err) {
        console.warn('[SalesPop] Nepavyko gauti produktų:', err && err.message ? err.message : err);
        return [];
      });
  }

  var popupEl = null;
  var closeHandler = null;
  var clickHandler = null;

  function ensureEl() {
    if (popupEl) return popupEl;
    popupEl = document.createElement('div');
    var pos = config.position || {};
    var placement = pos.placement || 'bottom-left';
    popupEl.className = 'sp-popup sp-pos-' + placement;
    popupEl.setAttribute('role', 'status');
    popupEl.setAttribute('aria-live', 'polite');

    function px(v, fallback) {
      return (v == null ? fallback : v) + 'px';
    }
    if (placement === 'bottom-left') {
      popupEl.style.bottom = px(pos.offsetBottom, 100);
      popupEl.style.left = px(pos.offsetLeft, 40);
    } else if (placement === 'bottom-right') {
      popupEl.style.bottom = px(pos.offsetBottom, 100);
      popupEl.style.right = px(pos.offsetRight, 20);
    } else if (placement === 'top-left') {
      popupEl.style.top = px(pos.offsetTop, 20);
      popupEl.style.left = px(pos.offsetLeft, 0);
    } else if (placement === 'top-right') {
      popupEl.style.top = px(pos.offsetTop, 20);
      popupEl.style.right = px(pos.offsetRight, 20);
    }

    document.body.appendChild(popupEl);
    return popupEl;
  }

  function buildHTML(product, customer) {
    var imgUrl = product.featuredImage && product.featuredImage.url;
    var imgStyle = imgUrl ? 'background-image:url(' + escapeHtml(imgUrl) + ');' : '';
    var truncatedTitle = truncate(product.title, config.behavior.productTitleMaxChars);

    // Accept UPPERCASE and lowercase template variables.
    var vars = {
      CUSTOMER: customer.name, customer: customer.name, name: customer.name,
      LOCATION: customer.city, location: customer.city, city: customer.city,
      PRODUCT: truncatedTitle, product: truncatedTitle,
      MINUTES: customer.minutesAgo, minutes: customer.minutesAgo
    };

    var headline = render(config.text.template, vars);
    var timeAgo = render(config.text.timeAgoTemplate, vars);

    // Render the product line so that {PRODUCT} gets its own coloured span,
    // while the rest (e.g. "Užsisakė: ") keeps the base white color.
    var productTpl = String(config.text.productTemplate || '{PRODUCT}');
    var productParts = productTpl.split(/\{PRODUCT\}|\{product\}/);
    var productHTML;
    if (productParts.length >= 2) {
      productHTML =
        escapeHtml(productParts[0]) +
        '<span class="sp-product-name">' + escapeHtml(truncatedTitle) + '</span>' +
        escapeHtml(productParts.slice(1).join(''));
    } else {
      productHTML = escapeHtml(render(productTpl, vars));
    }

    var closeHtml = config.behavior.showCloseButton
      ? '<button class="sp-close" type="button" aria-label="' +
          escapeHtml(config.text.closeLabel) + '">&times;</button>'
      : '';

    var metaParts = [];
    if (config.behavior.showMeta) metaParts.push(escapeHtml(timeAgo));
    if (config.behavior.showVerified) {
      metaParts.push(
        escapeHtml(config.text.verifiedText) + ' <span class="sp-check">&#10003;</span>'
      );
    }
    var metaHtml = metaParts.length
      ? '<div class="sp-meta">' + metaParts.join(' &middot; ') + '</div>'
      : '';

    return (
      closeHtml +
      '<div class="sp-row">' +
        '<div class="sp-image" style="' + imgStyle + '" role="img" aria-label="' +
          escapeHtml((product.featuredImage && product.featuredImage.altText) || product.title) + '"></div>' +
        '<div class="sp-body">' +
          '<div class="sp-headline">' + escapeHtml(headline) + '</div>' +
          '<div class="sp-product">' + productHTML + '</div>' +
          metaHtml +
        '</div>' +
      '</div>'
    );
  }

  function show(el) {
    if (reducedMotion) {
      el.style.transform = 'none';
      el.classList.add('sp-show');
    } else {
      requestAnimationFrame(function () { el.classList.add('sp-show'); });
    }
  }

  function hide(el) {
    el.classList.remove('sp-show');
  }

  function detachHandlers() {
    if (popupEl) {
      if (closeHandler) popupEl.removeEventListener('click', closeHandler, true);
      if (clickHandler) popupEl.removeEventListener('click', clickHandler);
    }
    closeHandler = null;
    clickHandler = null;
  }

  function attachHandlers(product, onClose) {
    closeHandler = function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('sp-close')) {
        e.preventDefault();
        e.stopPropagation();
        if (config.behavior.pauseOnClose) {
          sessionSet(SESSION_DISMISSED_KEY, '1');
          log('Dismissed for session');
        }
        onClose();
      }
    };
    clickHandler = function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('sp-close')) return;
      markEngaged();
      trackEvent('click', {
        productId: product.id,
        productTitle: product.title,
        productHandle: product.handle
      });
      window.location.href = '/products/' + product.handle;
    };
    popupEl.addEventListener('click', closeHandler, true);
    popupEl.addEventListener('click', clickHandler);
  }

  function getCount() {
    return parseInt(sessionGet(SESSION_COUNT_KEY) || '0', 10) || 0;
  }
  function incCount() {
    sessionSet(SESSION_COUNT_KEY, String(getCount() + 1));
  }

  function schedule(products) {
    if (!products.length) { log('No products to display'); return; }
    injectStyles();
    var el = ensureEl();
    var lastProductId = null;
    var stopped = false;
    var hideTimer = null;
    var nextTimer = null;

    function stop() {
      stopped = true;
      clearTimeout(hideTimer);
      clearTimeout(nextTimer);
      hide(el);
      detachHandlers();
    }

    function showNext() {
      if (stopped) return;
      if (getCount() >= config.behavior.maxPerSession) {
        log('Reached maxPerSession (' + config.behavior.maxPerSession + ')');
        stop();
        return;
      }

      var product = pickDifferent(products, lastProductId, function (p) { return p.id; });
      lastProductId = product.id;

      var customer = {
        name: pick(config.names),
        city: pick(config.cities),
        minutesAgo: randInt(config.behavior.minMinutesAgo, config.behavior.maxMinutesAgo)
      };

      detachHandlers();
      el.innerHTML = buildHTML(product, customer);
      attachHandlers(product, stop);
      show(el);
      incCount();
      trackEvent('impression', {
        productId: product.id,
        productTitle: product.title,
        productHandle: product.handle
      });
      log('Showing', product.handle, 'count=', getCount());

      hideTimer = setTimeout(function () {
        hide(el);
        var jitter = randInt(-config.timing.randomness, config.timing.randomness);
        var gap = Math.max(500, config.timing.intervalBetween + jitter);
        nextTimer = setTimeout(showNext, gap);
      }, config.timing.displayDuration);
    }

    setTimeout(showNext, config.timing.initialDelay);
  }

  function start() {
    log('Starting with config', config);
    fetchProducts().then(schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
